// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\PortCall\ApiPortCallSelf.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Comment, CommentData, CommentOptions } from 'data/models/Comment';
import { Event, EventData, EventOptions } from 'data/models/Event';
import { PortCall, PortCallData, PortCallOptions } from 'data/models/PortCall';
import { PortCallVersion, PortCallVersionData, PortCallVersionOptions } from 'data/models/PortCallVersion';

// PortCallSelfData is the class that PortCallSelf serializes to/from
export interface PortCallSelfData {
    Id : number;
	
    Comments : CommentData[] | null;
    CommentsUrl : string | null;
    Events : EventData[] | null;
    Live : PortCallData | null;
    Versions : PortCallVersionData[] | null;
	
}

// PortCallSelfOptions is the class which may be passed to the PortCallSelf constructor to define optional initial data values
export interface PortCallSelfOptions {
    Id : number;
	
    Comments? : CommentOptions[] | null;
    CommentsUrl? : string | null;
    Events? : EventOptions[] | null;
    Live? : PortCallOptions | null;
    Versions? : PortCallVersionOptions[] | null;
	
}

export class PortCallSelf {
    public Id : DataSignal<number>;
	
    public Comments : SDataArray<Comment>;
    public CommentsUrl : DataSignal<string | null>;
    public Events : SDataArray<Event>;
    public Live : DataSignal<PortCall | null>;
    public Versions : SDataArray<PortCallVersion>;
	

    constructor();
    constructor(data : PortCallSelfOptions);
    constructor(data: PortCallSelfOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Comments = SArray<Comment>([]);
        this.CommentsUrl = jsonableObservable(S.value<string | null>(data && data.CommentsUrl !== undefined ? data.CommentsUrl : null));
        this.Events = SArray<Event>([]);
        this.Live = S.value<PortCall | null>(null);
        this.Versions = SArray<PortCallVersion>([]);
	    
    }

    static key(obj : PortCallSelf) {
        return obj.Id();
    }
    
    static dataKey(obj : PortCallSelfOptions) {
        return obj.Id;
    }

    static update(obj : PortCallSelf, data : PortCallSelfOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.CommentsUrl !== undefined) obj.CommentsUrl(data.CommentsUrl);
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/PortCallSelf.ts